import { createAction, props } from '@ngrx/store';
import { Principle } from '../../models/principle.model';

export const LoadPrinciples = createAction('[Principle] Load Principle');
export const LoadPrincipleSuccess = createAction('[Principle] Load Principle Success', props<{ principles: Principle[] }>());
export const LoadPrincipleFail = createAction('[Principle] Load Principle Fail', props<{ error: any }>());
